import { styled } from "@mui/material/styles";

export const LogoutButtonContent = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.custom.colors.mediMagenta,
  "& *": {
    marginRight: 5,
  },
}));
